import { History } from 'history';
import { Action, applyMiddleware, createStore, Store } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import { IApi } from '../api';
import { api } from '../data/api';
import { thunks } from './middleware';
import { pubSub } from './middleware/pubsub';
import createReducer, { IState } from './reducer';

export default (intialState = {} as IState, apiClient: typeof api, oldApiClient: IApi, history: History): Store<IState> => {
	// compose middleware for correct ordering
	const middleware = composeWithDevTools(
		applyMiddleware(
			thunks(apiClient, oldApiClient),
			// NOTE: Task-Based Property relies on this middleware to function correctly.
			// Please check this is safe to modify there as well
			pubSub
		)
	);
	return createStore<IState, Action, any, any>(createReducer(history), intialState, middleware);
};
